import React, { memo } from 'react';

import Image from 'next/image';

import { YandexPayWidget } from '@screens/Product/ui/YandexPayWidget/YandexPayWidget';
import MasterCardLogo from '@shared/assets/icons/mastercard.svg';
import MirLogo from '@shared/assets/icons/mir.svg';
import SbpLogo from '@shared/assets/icons/sbp.svg';
import VisaLogo from '@shared/assets/icons/visa.svg';
import { PaymentMethodType, YandexPayType } from '@shared/types/enums/pay.enum';
import { HStack } from '@shared/ui/Stack';
import { Tab, TabList, TabPanel, Tabs } from '@shared/ui/Tabs';

import clsMain from '../Form/Form.module.scss';
import cls from './PaymentMethods.module.scss';

type PaymentMethodsProps = {
  totalAmount: number;
  onClickPaymentMethodTab: (tab: string) => void;
};

export const PaymentMethods = memo<PaymentMethodsProps>(({ totalAmount, onClickPaymentMethodTab }) => (
  <div className={clsMain.plate}>
    <h2 className={clsMain.title}>Способы оплаты</h2>
    <div className={cls.subtitle}>Выберите тип оплаты</div>
    <Tabs defaultActiveTab={PaymentMethodType.BANK_CARD}>
      <TabList className={clsMain.tabList}>
        <Tab
          className={clsMain.tab}
          activeClassName={clsMain.activeTab}
          value={PaymentMethodType.BANK_CARD}
          onClick={onClickPaymentMethodTab}
        >
          Банковская карта/СБП
        </Tab>
        <Tab
          className={clsMain.tab}
          activeClassName={clsMain.activeTab}
          value={PaymentMethodType.YANDEX_PAY}
          onClick={onClickPaymentMethodTab}
        >
          Яндекс Пэй
        </Tab>
        <Tab
          className={clsMain.tab}
          activeClassName={clsMain.activeTab}
          value={PaymentMethodType.YANDEX_SPLIT}
          onClick={onClickPaymentMethodTab}
        >
          Сплит
        </Tab>
      </TabList>
      <TabPanel
        className={cls.tabPanelBank}
        value={PaymentMethodType.BANK_CARD}
      >
        <div className={cls.paymentMethodWrapper}>
          <HStack className={cls.paymentMethodIcons}>
            <Image
              src={SbpLogo}
              alt={''}
            />
            <Image
              src={VisaLogo}
              alt={''}
            />
            <Image
              src={MasterCardLogo}
              alt={''}
            />
            <Image
              src={MirLogo}
              alt={''}
            />
          </HStack>
          <div className={cls.paymentMethodText}>Доступные способы онлайн-оплаты</div>
        </div>
      </TabPanel>
      <TabPanel
        className={cls.tabPanelSplit}
        value={PaymentMethodType.YANDEX_PAY}
      >
        <YandexPayWidget
          price={totalAmount}
          type={YandexPayType.CARD}
        />
      </TabPanel>
      <TabPanel
        className={cls.tabPanelSplit}
        value={PaymentMethodType.YANDEX_SPLIT}
      >
        <YandexPayWidget price={totalAmount} />
      </TabPanel>
    </Tabs>
  </div>
));
